import SubcategoryPage from '@/components/template/SubcategoryPage';

const ZenStool = () => {
  const products = [
    {
      title: "Zen Stool Light",
      imageSrc: "https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?auto=format&fit=crop&q=80",
      url: "/proizvodi/zen-stool-light"
    },
    {
      title: "Zen Stool Dark",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80",
      url: "/proizvodi/zen-stool-dark"
    },
    {
      title: "Zen Stool Natural",
      imageSrc: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?auto=format&fit=crop&q=80",
      url: "/proizvodi/zen-stool-natural"
    }
  ];

  return (
    <SubcategoryPage
      title="Zen Stool"
      description="Minimalistični in meditativni Zen stolčki, zasnovani za ustvarjanje mirnega in uravnoteženega prostora."
      heroImage="https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default ZenStool;